import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function GuiaDeCompras() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.life';

  return (
    <main>
      <Navbar />

      <section className="relative w-full min-h-[55vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20open%20laptop%20displaying%20shopping%20spreadsheet%20next%20to%20coffee%20cup%20notebook%20and%20fashion%20magazine%20on%20warm%20wooden%20desk%2C%20organized%20creative%20workspace%2C%20soft%20morning%20sunlight%20from%20window%2C%20shopping%20planning%20concept%2C%20warm%20cozy%20aesthetic%2C%20editorial%20photography%2C%20clean%20professional%20composition&width=1920&height=900&seq=hoobuy-guia-compras-hero-s1a7&orientation=landscape"
            alt="Guia de Compras Hoobuy"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
        </div>
        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-20">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white text-xs md:text-sm font-medium tracking-wide mb-6">
              Guia de Compras
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white font-medium leading-tight mb-6">
              Guia de Compras Hoobuy
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-lg leading-relaxed">
              Tudo o que precisa de saber para comprar no Hoobuy com segurança. Do registo ao envio, um guia completo para compradores portugueses.
            </p>
          </div>
        </div>
      </section>

      <article className="relative bg-background-50 py-16 md:py-24 px-6 md:px-10">
        <div className="max-w-3xl mx-auto">
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6">
            Se está a começar agora no mundo das compras internacionais através do Hoobuy, este <strong className="text-foreground-900">guia de compras completo</strong> foi feito para si. Vamos explicar cada passo do processo, desde a criação de conta até à receção do produto em sua casa em Portugal.
          </p>

          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">Passo 1: Escolha o Seu Agente de Compras</h2>
          <p className="text-foreground-700 text-base leading-relaxed mb-4">
            O primeiro passo para comprar no Hoobuy é escolher um <strong className="text-foreground-900">agente de compras confiável</strong>. O agente funciona como intermediário entre si e os vendedores, tratando de toda a logística de compra, armazenamento e envio. Em 2026, existem várias opções disponíveis para compradores portugueses. Compare taxas de serviço, prazos de entrega e a qualidade do suporte ao cliente antes de tomar a sua decisão.
          </p>

          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">Passo 2: Encontre Produtos na Nossa Spreadsheet</h2>
          <p className="text-foreground-700 text-base leading-relaxed mb-4">
            Utilize a nossa <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer"><strong>Hoobuy Spreadsheet em português</strong></Link> para encontrar produtos verificados e organizados por categorias. Cada link na planilha foi revisto manualmente pela nossa equipa. Navegue por categorias como Tênis, Hoodies, Jaquetas ou Acessórios e encontre exatamente o que procura sem perder horas a pesquisar.
          </p>

          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">Passo 3: Copie o Link e Cole no Agente</h2>
          <p className="text-foreground-700 text-base leading-relaxed mb-4">
            Depois de encontrar o produto desejado, basta copiar o link e colá-lo na plataforma do seu agente. O agente irá processar a encomenda, verificar a disponibilidade do produto e informar o preço final incluindo taxas. Pode acompanhar todo o processo através do painel de controlo do agente.
          </p>

          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">Passo 4: Escolha o Método de Envio</h2>
          <p className="text-foreground-700 text-base leading-relaxed mb-4">
            O envio para Portugal oferece várias opções. As mais comuns incluem envio expresso (7-12 dias úteis), envio standard (12-20 dias úteis) e envio económico (15-30 dias úteis). Considere o peso da encomenda, o valor declarado e as possíveis taxas alfandegárias ao escolher o método de envio. A <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer">nossa equipa</Link> recomenda agrupar várias compras para reduzir os custos de envio.
          </p>

          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">Dicas Importantes para Compras Seguras</h2>
          <ul className="list-disc list-inside space-y-3 text-foreground-700 text-base leading-relaxed mb-6 pl-2">
            <li>Verifique sempre as avaliações do vendedor antes de comprar</li>
            <li>Compare preços entre diferentes vendedores para o mesmo produto</li>
            <li>Utilize agentes com proteção ao comprador e seguro de envio</li>
            <li>Guarde todos os comprovativos de pagamento e conversas com o vendedor</li>
            <li>Comece com compras pequenas para testar o agente e o processo</li>
          </ul>

          <div className="mt-12 p-6 md:p-8 bg-background-100 rounded-2xl">
            <h3 className="font-heading text-lg text-foreground-900 font-medium mb-4">Leia Também</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <Link to="/" className="flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-home-4-line"></i> Voltar à Página Inicial
              </Link>
              <Link to="/artigo/hoobuy-e-seguro" className="flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-shield-check-line"></i> Hoobuy é Seguro?
              </Link>
            </div>
          </div>
        </div>
      </article>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org", "@type": "Article",
        "headline": "Guia de Compras Hoobuy: Como Comprar com Segurança",
        "description": "Guia completo para comprar no Hoobuy a partir de Portugal. Passo a passo desde a escolha do agente até ao envio.",
        "author": { "@type": "Organization", "name": "Equipe Hoobuy Life" },
        "datePublished": "2026-03-10", "dateModified": "2026-06-26", "inLanguage": "pt-PT",
        "isPartOf": { "@type": "WebSite", "name": "Hoobuy Life", "url": `${siteUrl}/` },
        "breadcrumb": { "@type": "BreadcrumbList", "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Início", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "Guia de Compras Hoobuy", "item": `${siteUrl}/artigo/guia-de-compras-hoobuy` }
        ]}
      }) }} />
    </main>
  );
}